<template>
  <div class="amazon_edit" style="width: 90%">
    <Breadcrumb></Breadcrumb>
    <div style="text-align: right; margin: 0 0 8px 0; padding-top: 10px">
      <el-button @click="handleQuit()" size="small">取消</el-button>
      <el-button @click="handleSaveForm" size="small" type="primary"
        >保存汇出记录</el-button
      >
    </div>
    <el-form ref="form" label-width="200px" :model="form">
      <div id="selectTemplate" class="basic">
        <div class="title">选择模板</div>
        <el-form-item label="汇出产品：">
          {{ productName }}
        </el-form-item>
        <el-form-item label="汇出产品数：">
          {{ productName.split("，").length }}
        </el-form-item>
        <el-form-item
          :rules="[{ required: true, message: '请输入内容', trigger: 'blur' }]"
          prop="shopId"
          label="所属店铺："
        >
          <el-select
            clearable
            filterable
            style="width: 100%"
            size="mini"
            v-model="form.shopId"
            placeholder="请选择所属店铺"
          >
            <el-option-group
              v-for="group in shopList"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.shopList"
                :key="item.value"
                :label="item.shopName"
                :value="item.shopId"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item
          :rules="[{ required: true, message: '请输入内容', trigger: 'blur' }]"
          prop="templateId"
          label="汇出范本："
        >
          <el-select
            clearable
            filterable
            style="width: 100%"
            size="mini"
            v-model="form.templateId"
            placeholder="请选择汇出范本"
          >
            <el-option
              v-for="(record, index) in templateList"
              :key="index"
              :label="record.templateName"
              :value="record.templateId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>

    <Template
      v-if="form.templateId"
      :designId="form.designId"
      :templateId="form.templateId"
      :shopId="form.shopId"
      ref="template"
      @save="handleSaveForm"
      @submit="handleSubmit"
    ></Template>
  </div>
</template>

<script type="text/ecmascript-6">
import Template from './components/template.vue'
import { getTemplateList } from "@/api/template/template";
import { getShopList } from "@/api/shop/shop";
import Breadcrumb from "@/components/common/Breadcrumb";

export default {
  name: "createTemplateData",
  components: { Template, Breadcrumb },
  data() {
    return {
      form: {
        shopId: '',
        templateId: '',
        designId: ''
      },
      templateList: [],
      shopList: [],
      priceConfigVisible: true
    };
  },
  computed: {
    productName(){
      return this.$route.query.name
    }
  },
  methods: {
    async getShopList(){
      let result = await getShopList()
       let shopList = [{ label: '亚马逊店铺' , shopList: []},
        { label: '其他店铺' , shopList: []}]
      for(let record of result.rows){
        if(record.platNo == '04'){
          shopList[0].shopList.push(record)
        }  else if(record.platNo == '09'){
          shopList[1].shopList.push(record)
        }
      }
      this.shopList = shopList
    },
    async getTemplateList(){
      let result = await getTemplateList()
      this.templateList = result.rows
    },
    handleSaveForm(){
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$refs['template'].handleSaveForm()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleSubmit(){
      let pId = this.$route.query.pId
      let designId = this.$route.query.designId
      if(pId){
        this.$router.push({
        path: '/product/amazon/remit'
        })

      }else if(designId){
        this.$router.push({
          path: '/carry/amazon/remit'
        })
      }
    },
    handleQuit(){
      this.$router.go(-1)
    }
  },
 async mounted() {
    this.form.designId = this.$route.query.designId
    this.getShopList()
    this.getTemplateList()
  },
};
</script>

<style lang="scss" scoped>
.amazon_edit {
  background: #ffffff;
  padding: 16px;
  box-sizing: border-box;
  .basic {
    padding: 0 0 0 32px;
  }
  .title {
    border-left: 4px solid #409eff;
    padding-left: 15px;
    font-size: 16px;
    margin-bottom: 30px;
  }
  ::v-deep .el-form-item__content {
    width: 600px;
  }
}
</style>
